"use client";
import { createContext, useContext } from "react";
import { Connection } from "..";

export const ConnectionContext = createContext<Connection | null>(null);

export const useCurrentConnection = () => {
  const connection = useContext(ConnectionContext);
  if (!connection) {
    return null;
  }
  return connection;
};
